export default function ConnectionLine({
  startX,
  startY,
  endX,
  endY,
  isFilled = false,
  isShared = false,
  invertCurve = false
}) {
  // Calculate control points for a visible arc
  const dx = endX - startX;
  const dy = endY - startY;

  // Control point offset perpendicular to the line
  // Invert curve for top-right and bottom-left quadrants
  let perpOffsetX, perpOffsetY;
  let shouldInvert = (endX > startX && endY < startY) || (endX < startX && endY > startY);

  // Apply manual invert override if specified
  if (invertCurve) {
    shouldInvert = !shouldInvert;
  }

  if (shouldInvert) {
    // Top-right or bottom-left - invert the curve
    perpOffsetX = -dy * 0.3;
    perpOffsetY = dx * 0.3;
  } else {
    // Top-left or bottom-right - normal curve
    perpOffsetX = dy * 0.3;
    perpOffsetY = -dx * 0.3;
  }

  const controlX = startX + dx * 0.5 + perpOffsetX;
  const controlY = startY + dy * 0.5 + perpOffsetY;

  // Determine stroke color based on shared status
  const strokeColor = isShared ? '#f97316' : '#6366f1'; // orange for shared, purple for regular

  return (
    <svg
      className="absolute top-0 left-0 w-full h-full pointer-events-none"
      style={{ zIndex: 1 }}
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      {isFilled ? (
        <>
          {/* Pulsing glow effect */}
          <path
            d={`M ${startX},${startY} Q ${controlX},${controlY} ${endX},${endY}`}
            stroke={strokeColor}
            strokeWidth="4"
            opacity="0.4"
            fill="none"
            vectorEffect="non-scaling-stroke"
          >
            <animate
              attributeName="opacity"
              values="0.2;0.6;0.2"
              dur="2s"
              repeatCount="indefinite"
            />
          </path>
          {/* Solid line */}
          <path
            d={`M ${startX},${startY} Q ${controlX},${controlY} ${endX},${endY}`}
            stroke={strokeColor}
            strokeWidth="2"
            opacity="0.8"
            fill="none"
            vectorEffect="non-scaling-stroke"
          />
        </>
      ) : (
        /* Dashed line for empty slots */
        <path
          d={`M ${startX},${startY} Q ${controlX},${controlY} ${endX},${endY}`}
          stroke={strokeColor}
          strokeWidth="2"
          strokeDasharray="5,5"
          opacity="0.6"
          fill="none"
          vectorEffect="non-scaling-stroke"
        />
      )}
    </svg>
  );
}
